import { reactive } from "vue";
import { api, ShomeiEntry } from "~/api";
import { InsertShomei } from "~/api/shomei/commands/InsertShomei";
import { Log } from "~/extensions/utils";
const log = Log.create("ShomeiEntryiStore");
class Store {
    shomeiEntry = reactive(new ShomeiEntry());
    privacyConsent = null;
    async load(shomeiNo) {
        this.shomeiEntry = await api.shomei.find(shomeiNo);
    }
    setData(data) {
        this.shomeiEntry = data;
    }
    setPrivacyConsent(consent) {
        this.privacyConsent = consent ? 1 : 0;
    }
    clear() {
        this.shomeiEntry = new ShomeiEntry();
        this.privacyConsent = null;
    }
    async insert() {
        await api.shomei.insert(InsertShomei.create(this.shomeiEntry));
    }
    async find(shomeiNo) {
        this.shomeiEntry = await api.shomei.find(shomeiNo);
        this.shomeiEntry.fromEntry = false;
        this.shomeiEntry.isShakoShomei = this.shomeiEntry.shomeiKb === 1;
        this.shomeiEntry.isKyojuShomei = this.shomeiEntry.shomeiKb === 3;
        this.shomeiEntry.isRentShomei = this.shomeiEntry.shomeiKb === 4;
    }
}
export let store = reactive(new Store());
